import styled from 'styled-components';
import { media } from 'theme';

export const PageContent = styled.div`
  width: 904px;
  padding: 23px 35px;
  background: white;
  margin: -45px auto 0;
  z-index: 1;
  border-radius: 4px;

  * {
    margin-bottom: 20px;
  }

  h1 {
    font-size: 20px;
  }

  h2 {
    background: ${props => props.theme.colors.seedlyBlue};
    color: white;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 45px;
    padding: 18px;

    ${media.smallAndUp`
      font-size: 24px;
    `}
  }

  h2:first-child {
    margin-top: 5px;
  }

  h3 {
    margin-bottom: 0px;
  }

  h6 {
    font-size: 14px;
    text-align: center;
    font-weight: inherit;
  }

  img {
    max-width: 100%;
    width: 100%;
    margin: 0;

    ${media.ie`
      flex: none;
    `}
  }

  ul > li {
    list-style-type: circle;
    margin-bottom: 0;
  }

  ol > li {
    list-style-type: decimal;
    margin-bottom: 0;
  }

  ul {
    margin-bottom: 0;
  }

  li {
    margin-left: 30px;
    padding-bottom: 3px;
  }

  a:link {
    color: ${props => props.theme.colors.seedlyBlue};
  }

  a:visited {
    color: ${props => props.theme.colors.seedlyBlue};
  }

  ${media.largeAndDown`
    width: 100%;
    padding: 23px 25px;
  `}
`;

export const Title = styled.div`
  background: #dee3f0;
  color: ${props => props.theme.colors.neutral7};
  width: 100%;
  height: 381px;
  position: relative;
  text-align: center;

  ${media.largeAndDown`
    height: 200px;
  `}

  > div {
    margin: 163px 0;

    ${media.largeAndDown`
      margin: 75px 0;
    `}
  }

  h1 {
    font-size: 26px;
    font-weight: bold;

    ${media.largeAndDown`
      font-size: 16px;
    `}
  }

  p {
    font-size: 16px;

    ${media.largeAndDown`
      font-size: 12px;
    `}
  }
`;
